import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useContractors } from '../../../queryHooks/useContractors';

type FormContractorSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormContractorSelect = (props: FormContractorSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('warehouse.outboundDeliveries.filters');
  const { data, isLoading } = useContractors();

  const options = data?.map((contractor) => {
    return { id: contractor.id, label: contractor.name };
  });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('client')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
